import { Metadata, PaginatedResponse, Pagination } from "../types/Common"

// Paginated results metadata
export const DefaultPagination: Pagination = {
  total: 0,
  page: 0,
  pages: 0,
  page_size: 0,
}

export const DefaultMetadata: Metadata = {
  pagination: DefaultPagination,
}

export const DefaultPaginatedResponse: PaginatedResponse = {
  metadata: DefaultMetadata,
  records: [],
}
